"use client";

import { useTranslations } from "next-intl";

interface ColorPickerProps {
  colors: string[];
  selected: string;
  onChange?: (color: string) => void;
  disabled?: boolean;
}

export function ColorPicker({ colors, selected, onChange, disabled = false }: ColorPickerProps) {
  const t = useTranslations("lists");

  const rows: string[][] = [];
  for (let i = 0; i < colors.length; i += 5) {
    rows.push(colors.slice(i, i + 5));
  }

  return (
    <div role="radiogroup" aria-label={t("chooseColor")} className="space-y-4">
      {rows.map((row, rowIndex) => (
        <div
          key={`row-${rowIndex}`}
          className="flex items-center justify-between"
          role="group"
          aria-label={t("colorRow", { row: rowIndex + 1 })}
        >
          {row.map((color) => (
            <button
              key={color}
              type="button"
              role="radio"
              aria-checked={selected === color}
              onClick={() => onChange?.(color)}
              disabled={disabled}
              className={`size-12 sm:size-14 rounded-full transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${
                selected === color ? "ring-2 ring-offset-2 ring-offset-background" : ""
              } ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
              style={{ backgroundColor: color, ["--tw-ring-color" as any]: color }}
              aria-label={t("selectColor", { color })}
            />
          ))}

          {Array.from({ length: Math.max(0, 5 - row.length) }).map((_, i) => (
            <span
              key={`ph-${rowIndex}-${i}`}
              aria-hidden="true"
              className="size-10 sm:size-12 rounded-lg opacity-0 pointer-events-none"
            />
          ))}
        </div>
      ))}
    </div>
  );
}
